import app from '$$app';
import store from '../../../store/main';

function onRoleProjectUpdated(event) {
  store.commit('roles/setCollaborationData', { type: 'project', updated: event.data.updated });

  app.trigger('onAfterCollaboration', {
    event: event.event,
    data: event.data,
  });
}

export default onRoleProjectUpdated;
